import React, { useState, useEffect } from 'react';
import Input from '../common/Input';
import VendorList from './VendorList';
import { omit, map } from 'lodash';
import { getVendorAccounts } from '../service/vendorService';
import VendorNavigation from './VendorNavigation';

const initialState = {
  vendorAccountName: '',
  vendorMsisdn: '',
  minBalance: 0,
  maxBalance: 50000000
};

let captions = [
  'ID',
  'Vendor Name',
  'Vendor Contact',
  'Minimum Amount',
  'Maximum Amount',
  'Is Active'
];

const Vendor = () => {
  const [vendorState, setVendorState] = useState(initialState);
  const [items, setItems] = useState([]);

  useEffect(() => {
    getVendorAccounts()
      .then(response => {
        let vendors = response.data.data;
        const updatedVendors = map(vendors, item => {
          return omit(item, ['createdAt']);
        });
        setItems(updatedVendors);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setVendorState(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = e => {
    let copyItems = [...items];
    e.preventDefault();
    copyItems.unshift(vendorState);
    setItems(copyItems);
  };

  return (
    <div>
      <VendorNavigation />
      <div className='row mb-3'>
        <div className='col-md-6 offset-0'>
          <div className='card'>
            <div className='card-body'>
              <form onSubmit={handleSubmit}>
                <div className='form-group row'>
                  <label className='col-md-4 col-form-label'>
                    Vendor Account Name
                  </label>
                  <div className='col-md-8'>
                    <Input
                      type='text'
                      name='vendorAccountName'
                      value={vendorState.vendorAccountName}
                      className='form-control form-control-sm custom-input'
                      onChange={handleChange}
                      muted='Names which better describes the vendor'
                    />
                  </div>
                </div>
                <div className='form-group row'>
                  <label className='col-md-4 col-form-label'>
                    Vendor Msisdn
                  </label>
                  <div className='col-md-8'>
                    <Input
                      type='text'
                      name='vendorMsisdn'
                      value={vendorState.vendorMsisdn}
                      onChange={handleChange}
                      className='form-control form-control-sm custom-input'
                      muted='Vendor phone contact'
                    />
                  </div>
                </div>
                <div className='form-group row'>
                  <label className='col-md-4 col-form-label'>
                    Minimum Balance
                  </label>
                  <div className='col-md-8'>
                    <Input
                      type='text'
                      name='minBalance'
                      value={vendorState.minBalance}
                      onChange={handleChange}
                      className='form-control form-control-sm custom-input'
                    />
                  </div>
                </div>
                <div className='form-group row'>
                  <label className='col-md-4 col-form-label'>
                    Maximum Balance
                  </label>
                  <div className='col-md-8'>
                    <Input
                      type='text'
                      name='maxBalance'
                      value={vendorState.maxBalance}
                      onChange={handleChange}
                      className='form-control form-control-sm custom-input'
                    />
                  </div>
                </div>
                <div className='form-row'>
                  <button className='btn btn-primary search-button'>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <VendorList
        keyTitle='vendorAccountName'
        items={items}
        captions={captions}
      />
    </div>
  );
};

export default Vendor;
